/**
 * Display video room using Janus SFU.
 *
 * @memberof videoroomClient
 * @ngdoc controller
 * @name videoroomCtrl
 * @scope
 * @description
 *   Main controller videoroom client
 * @param $rootScope {service}
 *   Every application has a single root scope. All other scopes are descendant scopes of the root scope.
 * @param $scope {service}
 *   Controller scope
 * @param config {service}
 *   Used for accessing application-wide constants
 * @attribute {string} name
 *   Value based on call to attendeeService.getScreenName()
 * @attribute {string} email
 *   Value based on call to attendeeService.getEmail()
 * @attribute {string} attendantId
 *   Value based on call to attendeeService.getAttendantId()
 * @attribute {boolean} isHost
 *   Value based on call to attendeeService.getIsHost()
 */

// This videoroomCtrl.js file is refactored into separate services in a multi-phase process:
//
// In phase 1: the code is split into several files, one per feature or functionality. These files
// reside in the ../services/ subdirectory. Let's call them submodules. The goal of phase 1 is to not
// change any application logic (or real line of code) but just split the code into separate files.
// To facilitate smooth transition, the original code is kept as commented out above. At this stage,
// the submodule files are not angular-style services, but just have part of the code and data
// on the same videoroomCtrl object. In particular, the initialize function in that submodule
// initializes the code and data on the videoroomCtrl object (self) passed as the argument.
//
// In phase 2: the submodules are converted into normal angular service files. This phase can be done
// incrementally and on-need basis. As a feature goes into general availability, that is given priority
// for conversion. Eventually, all the submodules will be converted to services, completing the refactor.
// In the lists below, the parts list is the list of new submodules, and the args are the original
// dependencies injected to videoroomCtrl, which are then transfered to the individual submodule on
// demand. The videoGlobalService file is a temporary store for the dependencies, so that existing
// unit tests of videoroomCtrl.js work, during the refactor phases. Once the refactor is completed,
// the videoGlobalServer file will not be needed anymore.

var videoroomClientData = {
    args: [
        '$rootScope',
        '$q',
        '$scope',
        '$timeout',
        '$interval',
        '$window',
        '$document',
        'config',
        'logService',
        'attendeeService',
        'connectivityService',
        'phoneConferenceService',
        'socketService',
        'attendeeListService',
        'helperService',
        'localStreamManagerService',
        'avDeviceService',
        'sdpTransformService',
        'contentService',
        'meetingService',
        'storageService',
        'screenShareService',
        'analyticsWrapperService',
        'annotationService',
        'supportLinkService',
        'notificationService',
        'brandingService',
        'localizationService',
        'msgFlowFactory',
        'videoroomService',
        'cookieService',
        'videoFilterService'
    ],
    parts: [
        'videoBitrateService',
        'videoCanvasService',
        'videoConnectService',
        'videoConnectivityService',
        'videoContentStateService',
        'videoDeviceService',
        'videoEncryptService',
        'videoFaceTrackService',
        'videoFeatureFlagsService',
        'videoRemoteFlagsService',
        'videoFileShareService',
        'videoGlobalService',
        'videoInitializeService',
        'videoKeyFrameService',
        'videoLayoutAlgorithmService',
        'videoLayoutDragService',
        'videoLayoutElementService',
        'videoLayoutLockService',
        'videoLayoutMoveService',
        'videoLayoutPageService',
        'videoLayoutPinService',
        'videoLayoutReuseService',
        'videoLayoutService',
        'videoLayoutSpotlightService',
        'videoLayoutZoomService',
        'videoLossIndicatorService',
        'videoLowPerformanceService',
        'videoMediaConstraintsService',
        'videoMediaPathService',
        'videoMediaService',
        'videoOnScreenService',
        'videoParamsService',
        'videoPlayService',
        'videoPopoutService',
        'videoPublishService',
        'videoPublisherIdService',
        'videoReconnectService',
        'videoRecordAttachService',
        'videoScreenShareService',
        'videoSimulcastService',
        'videoSimulcastToggleService',
        'videoSizeService',
        'videoSpeedTestService',
        'videoStatsService',
        'videoStatsTestService',
        'videoStatsFrozenService',
        'videoStatsQualityBarsService',
        'videoTalkerLayoutService',
        'videoTestLayoutService',
        'videoTestVideosService',
        'videoToggleService',
        'videoTouchBarService',
        'videoVoiceCallService',
        'videoLayoutCompactService'
    ]
};

function videoroomClientFunc() {
    var self = this;

    var dict = {},
        services = [];
    var values = arguments;
    var index = 0;
    videoroomClientData.args.forEach(function (name) {
        dict[name] = values[index++];
    });
    videoroomClientData.parts.forEach(function (name) {
        dict[name] = values[index++];

        if (name != 'videoGlobalService' && name != 'videoInitializeService') {
            services.push(dict[name]);
        }
    });

    dict.logService.log('videoroomClientFunc#initilization');
    dict.videoGlobalService.initialize(self, dict);
    dict.videoInitializeService.initialize(self);

    services.forEach(function (service) {
        service.initialize(self);
    });

    self.init();
}

videoroomClient.controller(
    'videoroomCtrl',
    [].concat(videoroomClientData.args, videoroomClientData.parts, [videoroomClientFunc])
);
